<template>
  <div class="leimonRobot padding80">
    <Header :current="0"></Header>
    <LeiMonContent :LeiMonContent="LeiMonContent"></LeiMonContent>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: "leimonRobot",
  data() {
    return {
      LeiMonContent: {
        noTitleType: false,
        title: "徕檬机器人",
        image: require("../../assets/content/content_robot.png"),
        tips:
          "采用虚拟柜员形象用标准动听的普通话全程引导客户完成面签，运用AI语音语义识别技术，使客户在面签过程中能够有和实际的银行真人交谈同样的流畅体验。流程中持续进行人脸检测、人脸识别、活体检测，有效进行客户身份验证，防止面签过程中可能发生的欺诈行为。",
        features: "功能特点",
        featuresEn: "FEATURES",
        list: [
          {
            title: "",
            icon: require("../../assets/content/content_robot_1.png"),
            tips: "基于流处理的实时音视频处理技术，保证良好的实时性。"
          },
          {
            title: "",
            icon: require("../../assets/content/content_robot_2.png"),
            tips:
              "7*24小时不间断服务，显著提高业务效率，降低面签业务办理成本。"
          },
          {
            title: "",
            icon: require("../../assets/content/content_robot_3.png"),
            tips:
              "动态扩展服务器计算资源和网络带宽，满足业务量增长需求。"
          }
        ]
      }
    };
  },
  created(){window,scrollTo(0,0)},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="less">
.leimonRobot {
}
</style>
